/* Hand-off between the Next up card on the bookings list and the booking
   sheet: the card's photo is measured at the tap and the sheet grows a copy
   of it from that spot into its own hero as it rises, so the card looks like
   it pushed up and opened out. Rows do not use this; they just slide. */

let pending = null;

export const setHeroHandoff = ({ id, src, rect }) => {
  pending = id && src && rect ? { id, src, rect: { left: rect.left, top: rect.top, width: rect.width, height: rect.height }, at: Date.now() } : null;
};

// Consumed once, and only if it is recent and for this booking.
export const takeHeroHandoff = (id) => {
  const h = pending;
  pending = null;
  if (!h || h.id !== id || Date.now() - h.at > 2000) return null;
  return h;
};

export const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

// The card's rect with the list at rest. Tapped within a moment of a sheet
// closing, the list is still easing back from its dimmed, scaled state and a
// plain measurement would land the photo a little off. Lift the transform
// for the measurement and put it straight back, before anything paints.
export const restRect = (el) => {
  const content = el.closest('.client-dashboard-content');
  if (!content) return el.getBoundingClientRect();
  const { transform, transition } = content.style;
  content.style.transition = 'none';
  content.style.transform = 'none';
  const r = el.getBoundingClientRect();
  content.style.transform = transform;
  content.style.transition = transition;
  return r;
};
